import { render } from "./ArticleListView.vue?vue&type=template&id=2bce7dde&scoped=true"
import script from "./ArticleListView.vue?vue&type=script&lang=js"
export * from "./ArticleListView.vue?vue&type=script&lang=js"

import "./ArticleListView.vue?vue&type=style&index=0&id=2bce7dde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bce7dde"]])

export default __exports__